import { render, staticRenderFns } from "./Bienvenida.vue?vue&type=template&id=0eb9a799"
import script from "./Bienvenida.vue?vue&type=script&lang=js"
export * from "./Bienvenida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports